import React from 'react';

import LinkPreview from '../../../common/LinkPreview';
import RichLocale from '../../../common2/RichLocale';
import Column from '../../../common/layout/Column';
import Heading3 from '../../../common/Heading3';
import Text from '../../../common/Text';
import Locale from '../../../Translate/Locale';
import QueryResult from '../../../common2/QueryResult';
import { UseMutationResult } from '@tanstack/react-query';
import ModalHeader from '../../../common2/Modal/ModalHeader';
import ModalContent from '../../../common2/Modal/ModalContent';
import ModalFooter from '../../../common2/Modal/ModalFooter';
import Button from '../../../common2/Button/Button';
import LinkIcon from '../../../../icons/link.svg';

import styles from './DORSigningLinkContent.scss';

type DORSigningLinkContentProps = {
  mutation: UseMutationResult<{ signingLink: string }, Error, string>;
  onClose: () => void;
};

function DORSigningLinkContent({ mutation, onClose }: DORSigningLinkContentProps) {
  return (
    <>
      <ModalHeader icon={LinkIcon} intent="info">
        DOR signing link created
      </ModalHeader>
      <ModalContent>
        <div className={styles.signingContentWrapper}>
          <QueryResult
            result={mutation}
            loadingText="DOR is being created"
            errorText="An error has occurred. Please try again"
          >
            {(result) => (
              <Column>
                <RichLocale ink>DOR_SIGNING_LINK_MESSAGE</RichLocale>
                <div className={styles.container}>
                  <Heading3>DOR Signing Link</Heading3>
                  <Text>
                    <Locale>Copy and send to your customer</Locale>
                  </Text>
                  <div className={styles.signingLink}>
                    <LinkPreview showCopyButton={true}>{result.data?.signingLink}</LinkPreview>
                  </div>
                </div>
              </Column>
            )}
          </QueryResult>
        </div>
      </ModalContent>
      <ModalFooter>
        <Button intent="primary" onClick={onClose}>
          OK
        </Button>
      </ModalFooter>
    </>
  );
}

export default React.memo(DORSigningLinkContent);
